enum PaywallMessagesEnum {
  PrivateEvent = 'Do dank shit with private events, Biproxi\'s custom solution to auctions. Available with a paid plan.',
  InvestorMatchCard = 'See your latest investor matches for this property and get leads faster! Available with a paid plan.',
  InvestorMatchTable = 'Interact with investors tailor-made for your property and close the deal that much faster. Available with a paid plan',
}

export default PaywallMessagesEnum;
